/**
 * Light/dark theme handling. Theming is driven by the `data-theme` attribute on
 * <html>, which DaisyUI uses to switch the whole UI via CSS — so toggling the
 * attribute restyles everything without React re-rendering.
 */
export type ThemeMode = 'light' | 'dark';

/** DaisyUI theme name per mode (defined in `styles/index.css`). */
export const THEME_NAME: Record<ThemeMode, string> = {
  light: 'cloudscape',
  dark: 'cloudscape-dark',
};

const STORAGE_KEY = 'pi-ule-portal:theme';

export function getStoredMode(): ThemeMode | null {
  try {
    const v = localStorage.getItem(STORAGE_KEY);
    return v === 'light' || v === 'dark' ? v : null;
  } catch {
    return null;
  }
}

/** Stored preference, else the OS preference, else light. */
export function getInitialMode(): ThemeMode {
  const stored = getStoredMode();
  if (stored) return stored;
  return typeof window !== 'undefined' &&
    window.matchMedia?.('(prefers-color-scheme: dark)').matches
    ? 'dark'
    : 'light';
}

export function applyMode(mode: ThemeMode): void {
  document.documentElement.setAttribute('data-theme', THEME_NAME[mode]);
}

export function storeMode(mode: ThemeMode): void {
  try {
    localStorage.setItem(STORAGE_KEY, mode);
  } catch {
    /* ignore persistence errors */
  }
}
